export async function loadPdfEngine() {
  const [engine, resources] = await Promise.all([
    import("pdfjs-dist/webpack.mjs"), import("./pdfResources"),
  ]);
  return { getDocument: (options) => engine.getDocument({
    ...options, useWorkerFetch: false, WasmFactory: resources.LocalWasmFactory,
    StandardFontDataFactory: resources.LocalFontFactory, CMapReaderFactory: resources.LocalCMapFactory,
  }) };
}
